import React, { useContext } from 'react'
import styled from 'styled-components'

import BodyText from 'components/Luxkit/Typography/BodyText'
import LinePhoneIcon from 'components/Luxkit/Icons/line/LinePhoneIcon'
import Image from 'components/Common/Image'
import TextLink from 'components/Luxkit/TextLink'
import { mediaQueryUp } from 'components/utils/breakpoint'
import ContactContext from 'contexts/contactContext'
import Group from 'components/utils/Group'
import { useIsMobileScreen } from 'lib/web/deviceUtils'

const ImageWrapper = styled.div`
  min-width: 68px;
  height: 68px;

  ${mediaQueryUp.tablet} {
    min-width: 84px;
    height: 84px;
  }
`
interface Props {
  className?: string;
}

function ContactUSP({ className }: Props) {
  const isMobileScreen = useIsMobileScreen()
  const currentContact = useContext(ContactContext)
  const contact = currentContact.defaultContact

  return (
    <Group
      className={className}
      gap={16}
      tabletGap={20}
      direction="horizontal-reverse"
      tabletDirection="horizontal"
      verticalAlign="start"
      tabletVerticalAlign="center"
      horizontalAlign="space-between"
      tabletHorizontalAlign="start"
    >
      <ImageWrapper>
        <Image fit="top" id="d5sfjdbpg47k0yfcxxzj" quality="best" width={isMobileScreen ? 68 : 84} />
      </ImageWrapper>
      <Group direction="vertical" gap={4}>
        <BodyText variant="medium" weight="bold">
          Our team are available 24 hours, 7 days
        </BodyText>
        <BodyText variant="medium" colour="neutral-three">
          Interested in this offer? Call us anytime.
        </BodyText>
        <TextLink
            size="medium"
            weight="bold"
            href={`tel:${contact.number}`}
            startIcon={<LinePhoneIcon />}
          >
          {contact.humanReadable}
        </TextLink>
      </Group>
    </Group>
  )
}

export default ContactUSP
